import React, { useEffect } from 'react'
import Modal from 'react-responsive-modal'
import {useDispatch, useSelector} from 'react-redux'
import styles from './styles.module.css'
import {useFormik} from 'formik'
import {Checkbox, Input, Select} from '../../components/ModalInputs'
import * as Yup from 'yup'
import ModalFooter from '../../components/ModalFooter/ModalFooter'
import {getTimeSlotItem, createTimeSlot, updateTimeSlot} from '../../actions/time_slot'

const validationSchema = Yup.object({
    name: Yup
        .string()
        .required('обязательное поле')
        .min(4, 'Должно быть не менее 4 символов')
        .max(30, 'Должно быть не более 255 символов'),
    starttime: Yup
        .string()
        .required('обязательное поле'),
    stoptime: Yup
        .string()
        .required('обязательное поле'),
    school_year: Yup
        .string()
        .required('обязательное поле'),
    stream: Yup
        .string()
        .required('обязательное поле'),
})

export default function ModalComponent({data, closeModal, height, addMode, setMode, schoolYears, streams, params}) {

    const dispatch = useDispatch();

    const {item} = useSelector(state => state.time_slot);

    useEffect(() => {
        !addMode &&
      dispatch(getTimeSlotItem(data?.id));
    }, [data?.id])

    const handleCreate = (values) => {
        dispatch(createTimeSlot(values, addMode, params));
        closeModal();
    }

    const handleUpdate = (values) => {
        dispatch(updateTimeSlot(values, params))
        closeModal();
    }

    const {
        values,
        errors,
        touched,
        submitCount,
        handleChange,
        handleSubmit
    } = useFormik({
        initialValues: addMode
            ? {
                name: '',
                starttime: '',
                endtime: '',
                school_year: '',
                stream: 0,
                service: 0
            }
            : item,
        enableReinitialize: true,
        validateOnChange: true,
        validationSchema: validationSchema,
        onSubmit: addMode
            ? handleCreate
            : handleUpdate
    })

    const error = (fieldName) => (touched[fieldName] || submitCount) && errors[fieldName]

    return (<>
            <Modal
                open={!!item}
                onClose={() => closeModal()}
                showCloseIcon={false}
                height={height}
                center
                closeOnOverlayClick={true}
                closeOnEsc={true}
                
                classNames={{
                    modal: styles.custom
                }}>
                <> <div className={styles.modalLocal}>
                    <div className={styles.tabWrapper}>

                    <div className={styles.inputsRow}>
                        <h2 >{addMode ? 'Добавить' : 'Редактировать'} временный слот</h2>
                    </div>

                        <div className={styles.inputsRow}>
                            <Input
                                label='Название'
                                value={values.name}
                                name='name'
                                error={error('name')}
                                onChange={(e) => handleChange(e)}
                                style={{
                                    width: '100%',
                                }}
                                />
                        
                            <Select
                                name='school_year'
                                value={values.school_year}
                                error={error('school_year')}
                                label='Год поступления'
                                onChange={handleChange}>
                                {[{xp_key: '', name: 'Выбрать'},...schoolYears]?.map(el => <option key={el.xp_key} value={el.xp_key}>{el.name}</option>)}</Select>
                            <Select
                                name='stream'
                                value={values.stream}
                                error={error('stream')}
                                label='Набор'
                                onChange={handleChange}>
                                {streams
                                    .map(el => <option key={el.value} value={el.value}>{el.name}</option>)}</Select>

                            <Checkbox
                                    error={error('service')}
                                    label='Служебный слот'
                                    name='service'
                                    checked={values.service}
                                    onChange={e => handleChange( {target: {name: 'service', value: !values.service}} )}
                                    style={{
                                        width: '100%',
                                    }}
                                />


                        </div>
                            <div style={{display: 'flex', flexDirection: "row", marginLeft: '2rem'}}>
                                <Input 
                                    value={values.starttime} 
                                    error={error('starttime')} 
                                    style={{marginRight: '1rem'}} 
                                    type='time' label='Начало'  
                                    name='starttime' 
                                    onChange={handleChange} />
                                <Input 
                                    value={values.stoptime} 
                                    error={error('stoptime')} 
                                    type='time' 
                                    label='Окончание' 
                                    name='stoptime' 
                                    onChange={handleChange} />
                            </div>
                    </div>
                </div>

                <ModalFooter handleSubmit={handleSubmit} closeModal={closeModal}/>
                </>
            </Modal>
        </>
    )
}
